import React from 'react'
import { Segment, Header } from 'semantic-ui-react'
import RecentListForm from '../../components/advertisement/recentListForm'
import firebase from '../../config/firebase'

const NewRecentList = ({ history }) => {
  const firebaseKey = firebase
    .database()
    .ref()
    .child('recent_list')
    .push().key

  return (
    <div>
      <Segment color="black">
        <Header size="large"> New Recent List </Header>
        <RecentListForm
          firebaseKey={firebaseKey}
          action="New"
          history={history}
        />
      </Segment>
    </div>
  )
}

export default NewRecentList



// WEBPACK FOOTER //
// ./src/containers/advertisement/newRecentList.js